(() => {
  const init = () => {
    document.querySelectorAll('[data-sl-mobile-buy]').forEach(bar => {
      if (bar.dataset.ready) return;
      const sectionId = bar.dataset.sectionId;
      const form = document.getElementById(`product-form-${sectionId}`);
      const primary = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const info = document.getElementById(`ProductInfo-${sectionId}`);
      if (!form || !primary || !info) return;
      bar.dataset.ready = 'true';
      const variants = JSON.parse(bar.querySelector('[data-sl-variants]').textContent);
      const action = bar.querySelector('[data-sl-mobile-submit]');
      const media = window.matchMedia('(max-width: 749px)');
      let queued = false;
      const sync = () => {
        queued = false;
        if (!bar.isConnected) return;
        const variant = variants.find(item => String(item.id) === form.querySelector('[name="id"]').value);
        if (variant) {
          const price = bar.querySelector('[data-sl-mobile-price]');
          if (price.textContent !== variant.price) price.textContent = variant.price;
          document.querySelectorAll('[data-sl-variant-size]').forEach(size => { if (size.textContent !== variant.size) size.textContent = variant.size; });
        }
        action.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true' || primary.classList.contains('loading');
        const label = primary.querySelector('span')?.textContent.trim() || primary.textContent.trim();
        if (action.textContent !== label) action.textContent = label;
        action.setAttribute('aria-busy', String(primary.classList.contains('loading')));
        const overlay = document.querySelector('cart-drawer.active, cart-notification.active, quick-add-modal[open], product-modal[open], dialog[open]');
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        bar.hidden = !media.matches || !!overlay || !!editing || primary.getBoundingClientRect().bottom >= 0;
        document.body.classList.toggle('sl-mobile-buy-visible', !bar.hidden);
      };
      const schedule = () => {
        if (!queued) { queued = true; requestAnimationFrame(sync); }
      };
      action.addEventListener('click', () => {
        if (action.disabled) return;
        primary.click();
        schedule();
      });
      form.addEventListener('change', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      media.addEventListener('change', schedule);
      const observer = new MutationObserver(schedule);
      observer.observe(info, { attributes: true, childList: true, subtree: true, characterData: true });
      const drawer = document.querySelector('cart-drawer');
      if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      const error = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (error) {
        new MutationObserver(() => {
          if (!error.hidden && error.textContent.trim()) {
            error.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        }).observe(error, { attributes: true, childList: true, subtree: true });
      }
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
